// ── Other Systems ─────────────────────────────────────────────────────────────
// External links in the top nav so staff can jump to every other SSS website
// from here (fleet-wide spec 2026-10-09; reference build is sss-inspection's
// client/src/utils/otherSystems.js). Same list in every app, minus the app
// itself, so CRM is not listed here.
//
// GEORGE'S FLEET + RENTALMAN ONLY. Pay Desk and AR Command Center live on
// Brenda's own build, not ours -- they stay off. NO JORGE, either one: Jorge
// Equipment Needs is a bot on the MinisForum with no website, and Jorge Live is
// leadership-only and not employee accessible. Payroll and Barge Dispatch stay
// off too.
//
// RentalMan uses the bare host on purpose: the deep link carries a version
// segment that breaks on their next upgrade, and the root redirects to their
// login.
// Safety Training is OFF until it is ready for staff: it is the customer-training
// LMS, still a draft, and most employees have no login (George 2026-10-09).
export const OTHER_SYSTEMS = [
  { label: 'RentalMan',         url: 'https://roleplayv3.intemposoftware.com/' },
  { label: 'Inspection Portal', url: 'https://inspection.selectsafetyusa.com/' },
  { label: 'Field Services',    url: 'https://fieldservices.selectsafetyusa.com/' },
  { label: 'Inventory',         url: 'https://inventory.selectsafetyusa.com/' },
  { label: 'Muster',            url: 'https://sss-time-and-attendance-production.up.railway.app/' },
];
